import { CapoPlugin } from "/var/www/html/collection-experience/frontend-2/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];